import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { EvaluatorService } from 'src/app/core/services/evaluator.service';

@Component({
  selector: 'app-evaluator-scheduling-view',
  templateUrl: './evaluator-scheduling-view.component.html',
  styleUrls: ['./evaluator-scheduling-view.component.scss']
})
export class EvaluatorSchedulingViewComponent implements OnInit {
  isLoading: boolean = false;
  applications;
  paginatedData: any[] = [];
  pageSize = 10;
  pageIndex = 0;
  searchControl = new FormControl()
  filteredApplications;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  evaluatorDetails;

  constructor(
    private evaluatorService: EvaluatorService,
    private router: Router
  ) {
    this.searchControl.valueChanges.subscribe(value => {
      this.filteredApplications = this.handleSearch(value)
    })
  }


  handleSearch(value: string) {
    if (!value) {
      return this.applications;
    }

    value = value.toLowerCase();

    return this.applications.filter(application => application.apn.includes(value)
    );
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.evaluatorDetails = JSON.parse(
      localStorage.getItem("evaluator_details")
    );
    this.evaluatorService.getApplications().subscribe((applications) => {
      this.applications = applications.data;
      this.applications = this.applications.filter(
        (e) => e.applicationStatus == 25 && e.workingPermitType == 1
      );
      this.filteredApplications = this.applications
      this.isLoading = false;
    });
  }

  handleSelect(item) {
    this.router.navigate(['/evaluator/dashboard/scheduling/result', item.id]);
  }

}
